import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ActivityAction } from '@stores/activity/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import VoteList from '@components/voteList';
import { formatTime } from '@utils/timeUtils';
import { copy } from '@utils/copy';
import AvatarList from '@components/avatarList';
import CommonPopup from '@components/commonPopup';
import CommonAlert from '@components/commonAlert';
import classNames from 'classnames';
import { Radio, Input, DatePickerProps, DatePicker } from 'antd';
import parse from 'html-react-parser';
import Toast from '@components/Toast';
import PostList from '@components/postList';
const { TextArea } = Input;
interface ActivityDetailPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    activity?: ActivityAction;
    activityId: any
    createFollowUser?: any
    followDelete?: any
    createActivityVote?: any
    likeClick?: any
    favoriteClick?: any
    postsUpdate?: (id: any, actionType: 'delete' | 'sink' | 'sticky', type: 'post' | 'comment', currentState?: boolean) => Promise<any>
}
interface ActivityDetailPCState {
    loading: boolean;
    error: any
    pageLoaded: any
    topicList?: any
    rewardPopupStatus: boolean
    rewardList: any
    rewardCheckValue: any
    reportPopupStatus: boolean
    reportReasonList: any
    reportReason: any
    reportDescription: any
    reportType?: any
    menuDropStatus: any
    selectedCommentId?: any  // 当前选中要操作的评论 id
    selectedCommentIsSink?: boolean  // 当前选中评论的沉贴状态
    selectedCommentIsSticky?: boolean  // 当前选中评论的置顶状态
    deletePopupStatus: boolean
    reportCommentId?: any
}
@inject('app', 'site', 'user', 'activity')
@observer
class ActivityDetailPCPage extends BasePage<ActivityDetailPCPageProps, ActivityDetailPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        // bannerList: [
        //     {url: 'https://wwwstatic.vivo.com.cn/vivoportal/files/resource/product/1763607113845/./images/pc/kv.png', id: 0},
        //     {url: 'https://wwwstatic.vivo.com.cn/vivoportal/files/resource/product/1763607113845/./images/pc/ksp1.png', id: 1},
        //     {url: 'https://wwwstatic.vivo.com.cn/vivoportal/files/image/series/20250529/1dd55147418f77aa29f0fbaef5143667.jpg', id: 2} 
        // ],
        topicList: [
            { content: '话题话题', id: 0, postCount: '534' },
            { content: '话题话话话话话话话话话话话话题', id: 0, postCount: '2534' },
            { content: '话题话话话话话话话话题', id: 1, postCount: '4' },
            { content: '话题话话话话题', id: 2, postCount: '34' },
            { content: '话题话话话话话话话话话话话话话话话话题', id: 2, postCount: '87899' },
            { content: '话题话话话话话话话话话题', id: 2, postCount: '498145' },
            { content: '话题话话', id: 2, postCount: '872' },
            { content: '话题话话话话话话话', id: 2, postCount: '98' },
        ],
        rewardPopupStatus: false,    // 打赏弹框
        rewardList: [
            { value: 1, check: false },
            { value: 5, check: false },
            { value: 10, check: false },
            { value: 20, check: false },
            { value: 50, check: false },
            { value: 100, check: false },
        ], // 打赏选项数组
        rewardCheckValue: 0,    // 打赏V币数
        reportPopupStatus: false,    // 举报弹框
        reportReasonList: [
            { value: '淫秽色情', label: '淫秽色情' },
            { value: '垃圾广告', label: '垃圾广告' },
            { value: '暴力恐怖', label: '暴力恐怖' },
            { value: '违规传播', label: '违规传播' },
            { value: '政治谣言', label: '政治谣言' },
            { value: '谩骂侮辱', label: '谩骂侮辱' },
            { value: '灌水发帖/评论', label: '灌水发帖/评论' },
            { value: '其他', label: '其他' },
        ],
        reportReason: '',   // 举报理由
        reportDescription: '',  // 举报描述
        reportType: 4,  // 举报类型0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
        menuDropStatus: false,  // 标题右侧管理下拉框状态，默认折叠
        selectedCommentId: '',  // 当前选中要操作的评论 id
        selectedCommentIsSink: false,
        selectedCommentIsSticky: false,
        // stickyPopupStatus: false,   // 置顶弹框
        // stickyType: 0,  // 置顶类型1为首页，2为话题，0为不置顶
        // stickyAt: '', // 置顶时间
        deletePopupStatus: false,   // 删除二次确认弹框
        reportCommentId: '',    // 举报的评论id
    };
    componentDidMount() {
        const { app, user, activity, activityId, site } = this.props as any;
        
        // 首屏预取表情数据（站点级）
        // if (site && !site.hasEmoji && !site.isEmojiLoading && typeof site.fetchEmoji === 'function') {
        //     site.fetchEmoji();
        // }
        super.componentDidMount();
    }

    // 跳转到帖子详情页
    handleThreadClick = (item: any) => {
        // if(item.type == 3) {    // 是活动
        //     this.props.history && this.props.history.push(`/activityDetail/${item.id}`);
        // } else {    // 是其他
        //     // this.props.history && this.props.history.push(`/threadDetail/${item.id}`);
        //     window.open(`/threadDetail/${item.id}`);
        // }  
        window.open(`/threadDetail/${item.id}`);
    };
    // 确认投票
    handleVoteSubmit = (selectedOptions: string[]) => {
        // console.log('用户选择了:', selectedOptions);
        // 这里可以发送到后端API
    };
    // 投票选择
    handleVoteChange = (selected: string[]) => {
        // console.log('选择变化:', selected);
    };

    // 打开打赏弹框
    openRewardPopup = () => {
        this.setState({
            rewardPopupStatus: true
        })
    }
    // 关闭所有弹框
    closePopup = () => {
        // Toast.info('关闭')
        this.setState({
            deletePopupStatus: false,   // 删除弹框
            rewardPopupStatus: false,   // 打赏弹框
            reportPopupStatus: false,   // 举报弹框
            menuDropStatus: false,  //右上角下拉框
        })
    }
    // 确定打赏
    rewardConfirm = () => {
        let { rewardCheckValue } = this.state;
        if (rewardCheckValue == 0) {
            Toast.info('请选择打赏V币数');
            return false;
        }
        const { activity, activityId } = this.props;
        if (activity) {
            let params: any = {
                id: activityId,
                type: 2, // 0是主题
                scoreReward: rewardCheckValue,
                source: 'PC'
            }
            activity.postsCreate(params).then(res => {
                if (res.code === 0) {
                    this.setState({
                        rewardPopupStatus: false,   // 打赏弹框
                    })
                } else {
                    Toast.info(res.msg);
                }

            })
        }
    }

    // 确定举报
    reportConfirm = () => {
        let { activityId } = this.props;
        let { reportReason, reportType, reportCommentId } = this.state;
        if (reportReason == '') {
            Toast.info('请选择举报理由');
            return false;
        }
        const { activity } = this.props;
        if (activity) {
            let params: any = {
                id: reportType == 4 ? activityId : reportCommentId,
                type: reportType, // 0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
                reason: reportReason
            }
            activity.createReports(params).then(res => {
                this.setState({
                    reportPopupStatus: false,   // 举报弹框
                    menuDropStatus: false,  // 举报下拉框收起
                })
            })
        }
    }
    // // 修改置顶时间
    // onChangeStickyAt = (date:any, dateString:any) => {
    //     console.log(date, dateString, '时间')
    //     this.setState({
    //         stickyAt: dateString
    //     })
    // }

    // // 设置置顶类型
    // setStickyType = (type: any) => {
    //     this.setState({
    //         stickyType: type
    //     })
    // }

    // 确定删除, type为帖子类型（普通帖、反馈、活动）；deleteType为删除类型（帖子、评论）
    deletThreadConfirm = (type, deleteType) => {
        // const { thread, threadId } = this.props;
        // // 这里调用删除帖子的接口
        // if (thread) {
        //     let params: any = {
        //         status: !status,
        //         id: threadId
        //     }
        //     thread.createThreadOpera(params)
        // }
        this.setState({
            deletePopupStatus: false
        })
    }

    // 当前活动用户信息
    activityUserInfo = (user: any) => {
        const { activity, createFollowUser, followDelete } = this.props;
        const activityData = activity?.activityData;
        const isFollowed = user?.isFollow;
        return (
            <div className={styles.userInfoBox}>
                <Avatar avatarUrl={user?.avatar} titleMark={user?.titleMark} size={50}></Avatar>
                <div className={styles.infoBox}>
                    <div className={styles.infoDetail}>
                        <div className={styles.userNameBox}>
                            <div className={styles.userName}>{user?.nickname}</div>
                            {user?.titleName&& <div className={styles.userTitle}>{user?.titleName}</div>}
                        </div>
                        <div className={styles.userModel}>{activityData?.source}</div>
                    </div>
                    {!isFollowed && <div className={styles.followBtn} onClick={() => createFollowUser()}>关注</div>}
                    {isFollowed && <div className={styles.followedBtn} onClick={() => followDelete && followDelete()}>已关注</div>}
                </div>
            </div>
        )
    }

    // 活动分享
    shareClick = () => {
        const { match, site } = this.props;
        let url = site?.apiBase;
        let content = `${url}/activityDetail/${this.props.activityId}`
        copy(content);
        Toast.success({ content: '复制成功' });
    }

    // 处理投票
    handleVoteClick = (option) => { 
        // 调用父组件传递的函数
        const { createActivityVote } = this.props;
        if (createActivityVote) {
            createActivityVote(option);
        }
    }
    // 处理删除评论
    handleDeleteComment = async () => {
        const { selectedCommentId } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'delete', 'comment');
            Toast.success({ content: '删除成功' });
            this.closeDeletePopup();
        } catch (error) {
            Toast.error({ content: '删除失败' });
        }
    }

    // 处理沉贴评论
    handleSinkComment = async () => {
        const { selectedCommentId, selectedCommentIsSink } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'sink', 'comment', selectedCommentIsSink);
            Toast.success({ content: selectedCommentIsSink ? '取消沉贴成功' : '沉贴成功' });
            this.closeMenuDropStatus();
        } catch (error) {
            Toast.error({ content: selectedCommentIsSink ? '取消沉贴失败' : '沉贴失败' });
        }
    }

    // 处理置顶评论
    handleStickyComment = async () => {
        const { selectedCommentId, selectedCommentIsSticky } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'sticky', 'comment', selectedCommentIsSticky);
            Toast.success({ content: selectedCommentIsSticky ? '取消置顶成功' : '置顶成功' });
            this.closeMenuDropStatus();
        } catch (error) {
            Toast.error({ content: selectedCommentIsSticky ? '取消置顶失败' : '置顶失败' });
        }
    }

    // 更新列表数据（已移至父组件 postsUpdate 方法中处理，此方法已废弃）
    updatePostList = (itemId: any, action: 'delete' | 'sink' | 'sticky') => {
        // MobX 数据更新现在在父组件 postsUpdate 中处理
    }
    // 关闭菜单下拉框
    closeMenuDropStatus = () => {
        this.setState({
            menuDropStatus: false,
            selectedCommentId: ''
        });
    }

    // 关闭删除弹框
    closeDeletePopup = () => {
        this.setState({
            deletePopupStatus: false,
            selectedCommentId: ''
        });
    }

    // 首页左侧侧内容
    readerLeft = () => {
        const { activity, createActivityVote } = this.props;
        let { rewardPopupStatus, rewardList, rewardCheckValue, reportPopupStatus, reportReasonList, menuDropStatus, deletePopupStatus } = this.state;
        if (!activity) { return null }
        const activityData = activity.activityData;
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
                if (domNode.name === 'img') {
                    // return (
                    // <img 
                    //     {...domNode.attribs} 
                    //     loading="lazy"
                    //     onError={(e) => {
                    //     e.currentTarget.style.display = 'none';
                    //     }}
                    // />
                    // );
                }
            },
            ...options
        };
        return (
            <div className={styles.leftContent}>
                <div className={styles.detailBox}>
                    <div className={styles.titleOutBox}>
                        {/* 活动标题 */}
                        <div className={styles.titleBox}>
                            {activityData?.isSticky && <img src={`${BASE_IMG_URL}/common/stick.png`} alt="" className={styles.postTag} />}
                            {activityData?.isReward && <img src={`${BASE_IMG_URL}/common/reward.png`} alt="" className={styles.postTag} />}
                            {activityData?.title}
                            {activityData?.topics?.map((topic: any) => (
                                <span className={styles.topicName} onClick={() => {
                                    this.props.history && this.props.history.push(`/topicDetail/${topic.id}`);
                                }}>{topic.name}</span>
                            ))}
                        </div>
                        <div className={styles.menuBox}>
                            <div className={styles.menuIcon} onClick={() => {
                                this.setState({
                                    menuDropStatus: !menuDropStatus
                                })
                            }}></div>
                            {menuDropStatus && <div className={styles.menuDropListBox}>
                                <div className={styles.menuDropItem} onClick={() => {
                                    this.setState({
                                        reportPopupStatus: true,
                                        reportType: 4
                                    })
                                }}>举报</div>
                            </div>}
                        </div>
                    </div>
                    {/* 活动作者 */}
                    {this.activityUserInfo(activityData?.user)}

                    <div className={styles.threadContentBox}>
                        <div className={styles.richeText}>
                            {parse(activityData?.content || '', parserOptions)}
                        </div>
                        {/* 投票 */}
                        <div className={styles.voteBox}>
                            <VoteList votesData={activityData?.votes} onSubmit={(option) => this.handleVoteClick(option)} />
                        </div>
                        {/* 活动合集 */}
                        <div className={styles.collectionList}>
                            {activityData?.collection?.map((item: any) => (
                                <div className={styles.collectionItem}>
                                    {item.coverUrl !== '' && <img src={item.coverUrl} alt="帖子合集" className={styles.collectionCover} onClick={() => this.handleThreadClick(item)} />}
                                    <div className={styles.collectionDetail}>
                                        <div className={styles.collectionTitle} onClick={() => this.handleThreadClick(item)}>{item.title || item.summary}</div>
                                        <div className={styles.collectionInfo}>
                                            <div className={styles.collectionUserBox}>
                                                <Avatar avatarUrl={item.avatar} officialSize={10} titleMark={item?.titleMark} size={22}></Avatar>
                                                <div className={styles.name}>{item.user?.nickname}</div>
                                            </div>
                                            <div className={styles.infoOperaBox} onClick={() => this.handleThreadClick(item)}>
                                                <div className={styles.operaItem}>
                                                    <img src={`${BASE_IMG_URL}/common/comment.png`} alt="" className={styles.icon}/>
                                                    <div className={styles.count}>{item.postCount}</div>
                                                </div>
                                                <div className={styles.operaItem} onClick={() => this.handleThreadClick(item)}>
                                                    <img src={`${BASE_IMG_URL}/common/like.png`} alt="" className={styles.icon}/>
                                                    <div className={styles.count}>{item.likeCount}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.threadBottomInfo}>
                        <div className={styles.postTime}>{formatTime(activityData?.createdAt)}</div>
                        {/* <div className={styles.postArea}>IP所属区域</div> */}
                    </div>
                    <div className={styles.operaCountList}>
                        <div className={styles.operaCountItem} onClick={() => this.props.likeClick && this.props.likeClick(activityData)}>
                            <img src={activityData?.isLiked ? `${BASE_IMG_URL}/common/liked.png` : `${BASE_IMG_URL}/common/like1.png`} alt="" className={styles.operaIcon} />
                            <div className={styles.operaCount}>{activityData?.likeCount}</div>
                        </div>
                        <div className={styles.operaCountItem} onClick={() => this.props.favoriteClick && this.props.favoriteClick(activityData?.isFavorite)}>
                            <img src={activityData?.isFavorite ? `${BASE_IMG_URL}/common/favorited.png` : `${BASE_IMG_URL}/common/favorite.png`} alt="" className={styles.operaIcon} />
                            <div className={styles.operaCount}>{activityData?.favoriteCount}</div>
                        </div>
                        <div className={styles.operaCountItem}>
                            <img src={`${BASE_IMG_URL}/common/comment1.png`} alt="" className={styles.operaIcon} />
                            <div className={styles.operaCount}>{activityData?.postCount}</div>
                        </div>
                        <div className={styles.operaCountItem} onClick={() => this.shareClick()}>
                            <img src={`${BASE_IMG_URL}/common/share.png`} alt="" className={styles.operaIcon} />
                            <div className={styles.operaCount}>{activityData?.shareCount}</div>
                        </div>
                    </div>
                </div>
                {/* 打赏弹框 */}
                <CommonPopup
                    visible={rewardPopupStatus}
                    title='支持作者继续创作'
                    onCancelChange={() => this.closePopup()}
                    onConfirmButtonChange={() => this.rewardConfirm()}
                >
                    {/* children 插槽内容 */}
                    <div className={styles.rewardListBox}>
                        {rewardList.map((item, index) => (
                            <div className={classNames(styles.rewardItem, rewardCheckValue === item.value ? styles.rewardItemActive : '')} onClick={() => {
                                this.setState({
                                    rewardCheckValue: item.value
                                })
                            }}>
                                {rewardCheckValue === item.value && <img src={`${BASE_IMG_URL}/common/icon2.png`} alt="" className={styles.icon} />}
                                {rewardCheckValue !== item.value && <img src={`${BASE_IMG_URL}/common/icon3.png`} alt="" className={styles.icon} />}
                                <div className={styles.text}>{item.value} V币</div>
                            </div>
                        ))}
                    </div>

                </CommonPopup>

                {/* 举报弹框 */}
                <CommonPopup
                    visible={reportPopupStatus}
                    title='举报'
                    onCancelChange={() => this.closePopup()}
                    onConfirmButtonChange={() => this.reportConfirm()}
                >
                    {/* children 插槽内容 */}
                    <div className={styles.reportPopupSlotBox}>
                        <div className={styles.reportText}><span className={styles.must}>*</span>举报理由<span>请选择举报理由</span></div>
                        <div className={styles.reportReasonListBox}>
                            <Radio.Group
                                name="radiogroup"
                                defaultValue={1}
                                onChange={(e) => {
                                    this.setState({
                                        reportReason: e.target.value
                                    })
                                }}
                                options={reportReasonList}
                            />
                        </div>
                        <div className={styles.reportText}>举报描述</div>
                        <TextArea rows={4} placeholder="请输入举报理由" maxLength={600} />
                    </div>
                </CommonPopup>

                {/* 置顶弹框 */}
                {/* <CommonPopup
                    visible={stickyPopupStatus}
                    title='置顶'
                    onCancelChange={()=>this.closePopup()}
                >
                    <div className={styles.stickyPopupSlotBox}>
                        <div className={styles.stickyItem}>
                            <div className={styles.stickyText}>置顶区域</div>
                            <div className={styles.stickyTypeList}>
                                <div className={classNames(styles.stickyItem, stickyType === 1 ? styles.stickyItemActive : '')} onClick={()=> this.setStickyType(1)}>话题</div>
                                <div className={classNames(styles.stickyItem, stickyType === 2 ? styles.stickyItemActive : '')} onClick={()=> this.setStickyType(2)}>全局</div>
                                <div className={classNames(styles.stickyItem, stickyType === 0 ? styles.stickyItemActive : '')} onClick={()=> this.setStickyType(0)}>取消置顶</div>
                            </div>
                        </div>
                        
                        <div className={styles.stickyText}>置顶时间</div>
                        <DatePicker onChange={(date, dateString)=> this.onChangeStickyAt(date, dateString)} className={styles.stickyAtInput}/>
                    </div>   
                </CommonPopup> */}

                {/* 删除二次确认弹框 */}
                <CommonAlert
                    visible={deletePopupStatus}
                    title='帖子删除后无法撤销，请确认是否删除'
                    onCancelChange={() => this.closePopup()}
                    onHidePopup={() => this.closePopup()}
                >
                </CommonAlert>
                <div className={styles.postListBox}>
                    <PostList
                        threadId={this.props.activityId}
                        threadType={2}
                        commentType={2}
                        handleSetState={(data, rep) => this.setState({ ...data }, () => {
                            console.log('handleSetState-data', data)
                        })}
                        onPostLike={(comment) => {
                            window.globalEnsureLogin(() => this.props.likeClick?.(comment, 'post'));
                        }}
                        onDeleteComment={async (itemId) => {
                            this.setState({ selectedCommentId: itemId });
                            await this.handleDeleteComment();
                        }}
                        onSinkComment={async (itemId, currentIsSink) => {
                            this.setState({ selectedCommentId: itemId, selectedCommentIsSink: currentIsSink });
                            try {
                                await this.props.postsUpdate?.(itemId, 'sink', 'comment', currentIsSink);
                                Toast.success({ content: currentIsSink ? '取消沉贴成功' : '沉贴成功' });
                            } catch (error) {
                                Toast.error({ content: currentIsSink ? '取消沉贴失败' : '沉贴失败' });
                            }
                        }}
                        onStickyComment={async (itemId, currentIsSticky) => {
                            this.setState({ selectedCommentId: itemId, selectedCommentIsSticky: currentIsSticky });
                            try {
                                await this.props.postsUpdate?.(itemId, 'sticky', 'comment', currentIsSticky);
                                Toast.success({ content: currentIsSticky ? '取消置顶成功' : '置顶成功' });
                            } catch (error) {
                                Toast.error({ content: currentIsSticky ? '取消置顶失败' : '置顶失败' });
                            }
                        }}
                    ></PostList>
                </div>
            </div>
        );
    }

    //  隐藏/展示
    updateDisplay = () => {

    }
    // 屏蔽帖子
    updateHidden = () => {

    }

    // 首页右侧内容
    readerRight = () => {
        const { user, activity, activityId } = this.props;
        if (!activity) { return null }
        const activityData = activity.activityData;
        // 是否作者本人
        const isSelf = user?.userInfo?.code && user?.userInfo?.code === activityData?.user?.code;
        // let isLogin = false;
        return (
            <div className={styles.rightContent}>
                {/* 用户信息 */}
                <SidebarUserInfo></SidebarUserInfo>
                
                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>

            </div>
        );
    }

    render() {
        const { app } = this.props;

        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div className={styles.wrapper}>
                {this.readerLeft()}
                {this.readerRight()}
            </div>)
        }

    }
}

export default withRouter(ActivityDetailPCPage);
